import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Calendar, X } from 'lucide-react';
export function NewsSection() {
  const [openModal, setOpenModal] = useState<number | null>(null);
  const news = [{
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=600&h=400&fit=crop&q=80',
    date: '04 Лютого 2026',
    title: 'Вивчаємо найкращі практики для вдосконалення нашого Простору',
    description: 'Долучаємося до міжнародних вебінарів та досліджень, щоб впроваджувати найкращі світові практики у нашу діяльність.',
    detailed: ['Простір Чесної Гри долучився до участі у вебінарі на базі University of Bristol, Bristol Hub for Gambling Harms Research, який відбувся 04 лютого 2026 року і був присвячений темі: Життєвий досвід: Історія, що надихає на одужання. Вебінар провів Lapido Abiose A., засновник та керівник GamblePause Initiative Africa, що є проектом дуже близьким до цілей та місії нашого Простору.', 'На вебінарі ми дізнались про цікаві висновки, які зробив спікер зі свого досвіду боротьби із залежністю. Отримана інформація стала дуже цінною для планування перших кроків у напрямку створення у нашому Просторі місця для тих, хто готовий звернутися за допомогою для подолання залежності.', 'Слідкуйте за наступними новинами. Приєднуйтесь до нашого Простору.']
  }, {
    image: 'https://images.unsplash.com/photo-1524178232363-1fb2b075b655?w=600&h=400&fit=crop&q=80',
    date: '03 Лютого 2026',
    title: 'Готуємо запуск освітнього курсу для свідомих батьків',
    description: 'Створюємо курс для батьків, які зацікавлені допомогти своїм дітям свідомо взаємодіяти з цифровим простором.',
    detailed: ['Долучилися до освітнього вебінару для батьків, які хочуть убезпечити своїх дітей від негативного впливу цифрового контенту, що відбувся 03 лютого 2026 року в рамках освітньої платформи Ara Project, Ara — Recovery for All. Це британська освітня платформа, яка проводить на постійній основі навчання в сфері запобігання залежності від азартних ігор.', "Отримали багато нової інформації, якою обов'язково поділимося на вебінарі для батьків, які цікавляться темою безпеки дітей в умовах стрімкого розвитку цифрового контенту.", 'Слідкуйте за новинами.']
  }, {
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&h=400&fit=crop&q=80',
    date: 'Травень 2026',
    title: 'Розпочинаємо процес приєднання до глобальної наукової спільноти',
    description: 'Наш Простір долучається до міжнародної конференції дослідників у сфері азартних ігор.',
    detailed: ['Працюємо над організацією долучення нашого Простору до CAGR (Current Advances in Gambling Research), конференції, яка збирає провідних дослідників в сфері гемблінгу, яка відбудеться в травні 2026 року в University of Helsinki.', "Наш Простір отримає можливість доєднатися до іншого глибоко експертного простору науковців і дослідників, які поділяться напрацюваннями, результатами досліджень і наукових досягнень в сфері вивчення соціальних явищ, пов'язаних з індустрією азартних ігор."]
  }];
  return <>
      <section id="news" className="py-20 bg-white" data-id="element-362">
        <div className="container mx-auto px-4" data-id="element-363">
          <div className="text-center mb-16" data-id="element-364">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-4" data-id="element-365">
              Останні новини з нашого простору
            </h2>
            <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full mb-6" data-id="element-366" />
            <p className="text-gray-600 text-lg" data-id="element-367">
              Слідкуйте за нашими оновленнями та подіями
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-368">
            {news.map((item, index) => <div key={index} className="group bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 flex flex-col" data-id="element-369">
                <div className="relative h-48 overflow-hidden" data-id="element-370">
                  <img src={item.image} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-371" />
                  <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-medium text-[#0A5E5C] flex items-center gap-1" data-id="element-372">
                    <Calendar size={12} data-id="element-373" />
                    {item.date}
                  </div>
                </div>

                <div className="p-6 flex flex-col flex-grow" data-id="element-374">
                  <h3 className="text-xl font-serif font-bold text-[#0A5E5C] mb-3 group-hover:text-[#D4A843] transition-colors" data-id="element-375">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 mb-6 text-sm leading-relaxed flex-grow" data-id="element-376">
                    {item.description}
                  </p>
                  <Button variant="primary" size="sm" fullWidth onClick={() => setOpenModal(index)} data-id="element-377">
                    Читати далі
                  </Button>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {openModal !== null && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setOpenModal(null)} data-id="element-378">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-379" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-380">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-381">
              <div className="flex items-center gap-3 pr-4" data-id="element-382">
                <Calendar className="w-5 h-5 text-[#D4A843] flex-shrink-0" data-id="element-383" />
                <h3 className="text-lg font-serif font-bold text-[#0A5E5C] line-clamp-2" data-id="element-384">
                  {news[openModal].title}
                </h3>
              </div>
              <button onClick={() => setOpenModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0" data-id="element-385">
                <X className="w-5 h-5" data-id="element-386" />
              </button>
            </div>
            <div className="p-6 space-y-4" data-id="element-387">
              <div className="text-sm text-[#D4A843] font-medium mb-2" data-id="element-388">
                {news[openModal].date}
              </div>
              {news[openModal].detailed.map((paragraph, i) => <p key={i} className="text-gray-700 leading-relaxed" data-id="element-389">
                  {paragraph}
                </p>)}
            </div>
          </div>
        </div>}
    </>;
}